import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMaggiore = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1000px",
	height: "1000px",
	viewBox: "0 0 1000 1000",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Group 21" }), /* @__PURE__ */ _jsx("g", {
		id: "10.-Checker",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group-21",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "icon_Background",
				x: 0,
				y: 0,
				width: 1e3,
				height: 1e3
			}), /* @__PURE__ */ _jsx("polygon", {
				id: ">",
				fill: "#424548",
				fillRule: "nonzero",
				points: "388.888889 650.111111 598.888889 525.611111 598.888889 485.611111 388.888889 361.111111 388.888889 403.111111 561.388889 503.611111 561.388889 507.611111 388.888889 608.111111"
			})]
		})
	})]
});
export default SvgMaggiore;
